var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpfrontPremiumIconCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 64.3019C49.6731 64.3019 64 49.9074 64 32.1509C64 14.3945 49.6731 0 32 0C14.3269 0 0 14.3945 0 32.1509C0 49.9074 14.3269 64.3019 32 64.3019Z",
    fill: "#5F797B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6888 32.9931L27.921 47.2516C27.9944 47.4681 27.7299 47.6347 27.5977 47.4681L16.6204 33.193C16.5176 33.0597 16.6057 32.8265 16.7674 32.8265H23.5124C23.6006 32.8265 23.6741 32.8932 23.6888 32.9765V32.9931ZM35.4596 21.1666L37.3405 29.2286C37.3699 29.3619 37.2818 29.4951 37.1495 29.4951H26.8629C26.7307 29.4951 26.6425 29.3619 26.6719 29.2286L28.5529 21.1666C28.5823 21.0666 28.6557 21 28.7439 21H35.2685C35.3567 21 35.4302 21.0666 35.4596 21.1666ZM37.1642 33.1264L32.1973 49.8501C32.1385 50.05 31.8887 50.05 31.8299 49.8501L26.8629 33.1264C26.8188 32.9931 26.907 32.8432 27.0393 32.8432H36.9732C37.1054 32.8432 37.1936 32.9931 37.1495 33.1264H37.1642ZM40.5 32.8432H47.2451C47.4067 32.8432 47.4949 33.0597 47.392 33.2096L36.4148 47.4681C36.2825 47.6514 36.018 47.4681 36.0915 47.2516L40.3237 32.9931C40.353 32.9098 40.4265 32.8432 40.5 32.8432ZM47.8182 29.4951H40.6029C40.5147 29.4951 40.4412 29.4285 40.4118 29.3285L38.5309 21.2665C38.5015 21.1333 38.5896 21 38.7219 21H43.1157C43.1157 21 43.2333 21.0333 43.2774 21.0999L47.9651 29.162C48.0533 29.3119 47.9651 29.4951 47.8035 29.4951H47.8182ZM20.882 21H25.2759C25.4081 21 25.4963 21.1333 25.4669 21.2665L23.5859 29.3285C23.5565 29.4285 23.483 29.4951 23.3949 29.4951H16.1943C16.0473 29.4951 15.9445 29.2952 16.0326 29.162L20.7351 21.0999C20.7351 21.0999 20.8232 21 20.8967 21H20.882Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpfrontPremiumIconCircle);
export default __webpack_public_path__ + "static/media/Upfront_Premium_Icon_circle.b132f4b3.svg";
export { ForwardRef as ReactComponent };